/**
 * Legal tags configuration organized by legal area (Rechtsgebiet)
 * Used in create-case-editor for filtering tags based on selected category
 */

export const LEGAL_TAGS_BY_CATEGORY = {
  'Zivilrecht': [
    'Schuldrecht BT',
    'Schuldrecht AT',
    'BGB AT',
    'Sachenrecht',
    'Handels- und Gesellschaftsrecht',
    'Zivilprozessrecht',
    'Erbrecht',
    'Arbeitsrecht',
    'Familienrecht',
    'Internationales Privatrecht',
    'Vertragliche Schuldverhältnisse',
    'Kauf, § 433 ff. BGB',
    'Mangel',
    'Nacherfüllung',
    'Rücktritt',
    'Minderung',
    'Schadensersatz',
    'Ausschlussgründe (§§ 442, 444 BGB)',
    'Konkurrenzen',
    'Garantie',
    'Verbrauchsgüterkauf',
    'Darlehen, §§ 488 ff. BGB',
    'Schenkung, §§ 516 ff. BGB',
    'Miete, §§ 535 ff. BGB',
    'Pacht, §§ 581 ff. BGB',
    'Leihe, §§ 598 ff. BGB',
    'Dienstvertrag, §§ 611 ff. BGB',
    'Behandlungsvertrag, §§ 630a ff. BGB',
    'Werkvertrag, §§ 631 ff. BGB',
    'Reisevertrag, §§ 651a ff. BGB',
    'Maklervertrag, §§ 652 ff. BGB',
    'Auftrag, §§ 662 ff. BGB',
    'Geschäftsbesorgung, §§ 675-675b BGB',
    'Zahlungsdienste, §§ 675c-676c BGB',
    'Verwahrung, §§ 688 ff. BGB',
    'Bürgschaft, §§ 765 ff. BGB',
    'Vergleich, § 779 BGB',
    'AGG',
    'Gesetzliche Schuldverhältnisse',
    'Geschäftsführung ohne Auftrag, §§ 677 ff. BGB',
    'Unerlaubte Handlung, §§ 823 ff. BGB',
    'Straßenverkehr, §§ 7 ff. StVG',
    'Bereicherungsrecht, §§ 812 ff. BGB',
    'Anwendbarkeit',
    'Leistungskondiktionen',
    'Nichtleistungskondiktionen',
    'Ausschlussgründe',
    'Drei-Personen-Verhältnis',
    'Umfang des Anspruchs',
    'Unbestellte Leistungen, § 241a BGB',
    'Schaden, §§ 249 ff. BGB',
    'Mitverschulden, § 254 BGB',
    'Schuldverhältnisse nach § 311 BGB',
    'Verletzung schuldrechtlicher Pflichten',
    'Unmöglichkeit',
    'Nichtleistung nach Fristsetzung',
    'Schuldnerverzug, § 286 BGB',
    'Nebenpflichtverletzung, § 241 II BGB',
    'Verschulden, §§ 276 ff. BGB (Maßstab/Zurechnung)',
    'Gläubigerverzug, §§ 293 ff. BGB',
    'Inhalt der Hauptleistungspflichten',
    'Leistungsumfang (§§ 262 ff., 315 ff. BGB)',
    'Leistungsmodalitäten (Ort, Zeit, Art)',
    'Einwendungen',
    'Einreden',
    'Erfüllung, § 362 BGB',
    'Aufrechnung, §§ 389 ff. BGB',
    'Erlass, § 397 I BGB',
    'Anerkenntnis, § 397 II BGB',
    'Rücktritt, §§ 323 ff. BGB',
    'Einrede des nicht erfüllten Vertrags, § 320 BGB',
    'Zurückbehaltungsrecht nach § 273 BGB',
    'Treu und Glauben, § 242',
    'Störung der Geschäftsgrundlage, § 313 BGB',
    'Verbraucherschutzrechte (insbesondere Widerruf)',
    'AGB, §§ 305 ff. BGB',
    'Dritte in Schuldverhältnissen',
    'Vertrag zugunsten Dritter, § 328 BGB',
    'Vertrag mit Schutzwirkung zugunsten Dritter',
    'Drittschadensliquidation',
    'Abtretung, gesetzlicher Forderungsübergang',
    'Schuldbeitritt, Schuld-, Erfüllungs-, Vertragsübernahme',
    'Mehrheit von Schuldnern',
    'Mehrheit von Gläubigern',
    'Verbraucher/Unternehmer',
    'Rechtsgeschäfte',
    'Willenserklärung',
    'Tatbestand',
    'Rechtsbindungswille (objektiv)',
    'Erklärungsbewusstsein (subjektiv)',
    'Abgabe/Zugang',
    'Vertragsschluss',
    'Auslegung',
    'Nichtigkeit',
    'Geschäftsfähigkeit, §§ 104 ff. BGB',
    'Form',
    'Gesetzliches Verbot, § 134 BGB',
    'Sittenwidrigkeit/Wucher, § 138 BGB',
    'Anfechtung, § 119 ff. BGB',
    'Verfügungsverbote, §§ 135-137 BGB',
    'Teilnichtigkeit ua, §§ 139-141 BGB',
    'Bedingung/Befristung, §§ 158 ff. BGB',
    'Stellvertretung, §§ 164 ff. BGB',
    'Zustimmung, Ermächtigung, §§ 182 ff. BGB',
    'Fristberechnung, §§ 186 ff. BGB',
    'Verjährung, §§ 194 ff. BGB',
    'Mobiliarsachenrecht',
    'Besitz',
    'Eigentum',
    '§§ 903 ff. BGB',
    'Rechtsgeschäftlicher Erwerb',
    'Gutgläubiger Erwerb',
    'Gesetzlicher Erwerb/§ 951 BGB',
    'Anwartschaftsrecht',
    'Pfandrecht',
    'Herausgabeanspruch, §§ 985, 986 BGB',
    'Eigentümer-Besitzer-Verhältnis (EBV)',
    'Konkurrenzen',
    'Schadensersatz',
    'Nutzungen',
    'Verwendungen',
    'Zurückbehaltungsrecht',
    'Beseitigungs- und Unterlassungsanspruch, § 1004 BGB',
    'Immobiliarsachenrecht',
    'Erwerb von Immobiliareigentum',
    'Gutgläubiger Erwerb',
    'Grundbuchberichtigung',
    'Vormerkung',
    'Hypothek',
    'Grundschuld',
    'Sonstige dingliche Rechte',
    'Handelsrecht',
    'Vollmachten',
    'Handelsregister, § 15 HGB',
    'Firmenrecht',
    'Handelsgeschäfte',
    'Allgemeine Vorschriften, §§ 343 ff. HGB',
    'Handelskauf, §§ 373 ff. HGB',
    'Gesellschaftsrecht',
    'Personengesellschaften',
    'GbR',
    'OHG',
    'KG',
    'Partnerschaftsgesellschaft',
    'Körperschaften',
    'GmbH',
    'AG',
    'Verein',
    'Erkenntnisverfahren',
    'Gerichtliche Zuständigkeit',
    'Rechtsbehelfe',
    'Partei-/Prozessfähigkeit',
    'Prozessstandschaft',
    'Parteimehrheit/-wechsel',
    'Versäumnisverfahren',
    'Prozessbeendigung',
    'Rechtskraft/Rechtshängigkeit',
    'Beweisrecht',
    'Zwangsvollstreckung',
    'Erinnerung',
    'Drittwiderspruchsklage',
    'Vollstreckungsabwehrklage',
    'Pfändungspfandrecht',
    'Allgemeine Vollstreckungsvoraussetzungen',
    'Gesetzliche Erbfolge',
    'Verfügung von Todes wegen',
    'Testament',
    'Wirksamkeit',
    'Gemeinschaftliches Testament',
    'Anfechtung',
    'Erbvertrag',
    'Vermächtnis',
    'Rechtsstellung des Erben',
    'Erbschaftsbesitzer, §§ 2018 ff. BGB',
    'Miterbengemeinschaft, §§ 2032 ff. BGB',
    'Vor- und Nacherben',
    'Erbschein',
    'Nachlassverbindlichkeiten',
    'Pflichtteilsansprüche',
    'Haftung des Erben',
    'Ausschlagung',
    'Schenkung von Todes wegen',
    'Arbeitnehmerbegriff',
    'Arbeitsverhältnis',
    'Inhalt',
    'Lohn ohne Arbeit',
    'Anspruch auf Beschäftigung',
    'AGB-Recht',
    'Direktionsrecht',
    'Betriebliche Übung',
    'Urlaub',
    'Befristung',
    'Überstundenvergütung',
    'AGG',
    'Schadensersatz',
    'Arbeitnehmerhaftung',
    'Arbeitgeberhaftung',
    'Kündigung',
    'Ordentliche Kündigung',
    'Außerordentliche Kündigung',
    'KSchG',
    'Aufhebungsvertrag',
    'Betriebsübergang, § 613a BGB',
    'Arbeitsgerichtsverfahren',
    'Geschäft zur Deckung des Lebensbedarfs, § 1357 BGB',
    'Eigentumsvermutung, § 1362 BGB',
    'Eheliches Güterrecht, §§ 1363 ff. BGB',
    'Verfügungen nach §§ 1365, 1369 BGB',
    'Zugewinnausgleich',
    'Unbenannte Zuwendungen',
    'Kindschaftsrecht',
    'Nichteheliche Lebensgemeinschaft',
    'Internationales Zivilverfahrensrecht',
    'Internationales Privatrecht',
    'Rom-Verordnungen',
    'EGBGB'
  ],
  
  'Strafrecht': [
    'StGB AT',
    'StGB BT', 
    'Strafverfahrensrecht',
    'Fahrlässigkeit',
    'Unterlassen',
    'Kausalität',
    'Garantenstellung',
    'Abgrenzung Täterschaft/Teilnahme',
    'Abgrenzung Tun/Unterlassen',
    'Täterschaft/Teilnahme',
    'Mittäterschaft, § 25 II StGB',
    'Mittelbare Täterschaft, § 25 I Alt. 2 StGB',
    'Anstiftung, § 26 StGB',
    'Beihilfe, § 27 StGB',
    'Besondere persönliche Merkmale, § 28 StGB',
    'Versuch der Beteiligung, § 30 StGB',
    'Konkurrenzen',
    'In dubio pro reo/Sachverhaltsalternativität',
    'Strafmilderung, § 46b StGB',
    'Diebstahl, § 242 StGB',
    'Fremde bewegliche Sache',
    'Gewahrsamsbruch/Gewahrsamsbegründung',
    'Absicht rechtswidriger Zueignung',
    'Besonders schwerer Fall des Diebstahls, § 243 StGB',
    'Diebstahlsqualifikation, § 244 StGB',
    'Unterschlagung, § 246 StGB',
    'Unbefugter Gebrauch eines Fahrzeugs, § 248b StGB',
    'Entziehung elektrischer Energie, § 248c StGB',
    'Raub, § 249 StGB',
    'Abgrenzung Raub/räuberische Erpressung',
    'Qualifiziertes Nötigungsmittel/Finalität',
    'Schwerer Raub, § 250 StGB',
    'Raub mit Todesfolge, § 251 StGB',
    'Räuberischer Diebstahl, § 252 StGB',
    'Erpressung, § 253 StGB',
    'Räuberische Erpressung, §§ 253, 255 StGB',
    'Räuberischer Angriff auf Kraftfahrer, § 316a StGB',
    'Betrug, § 263 StGB',
    'Täuschung/Irrtum',
    'Vermögensverfügung/Vermögensschaden',
    'Subjektiver Tatbestand',
    'Computerbetrug, § 263a StGB',
    'Versicherungsmissbrauch, § 265 StGB',
    'Erschleichen von Leistungen, § 265a StGB',
    'Untreue, § 266 StGB',
    'Scheck- und Kreditkartenmissbrauch, § 266b StGB',
    'Begünstigung, § 257 StGB',
    'Hehlerei, § 259 StGB',
    'Sachbeschädigung, § 303 StGB',
    'Körperverletzung, § 223 StGB',
    'Ärztlicher Heileingriff',
    'Gefährliche Körperverletzung, § 224 StGB',
    'Gift, § 224 I Nr. 1 StGB',
    'Waffen/gefährliches Werkzeug, § 224 I Nr. 2 StGB',
    'Hinterlistiger Überfall, § 224 I Nr. 3 StGB',
    'Gemeinschaftliche Begehung, § 224 I Nr. 4 StGB',
    'Lebensgefährdende Behandlung, § 224 I Nr. 5 StGB',
    'Schwere Körperverletzung, § 226 StGB',
    'Körperverletzung mit Todesfolge, § 227 StGB',
    'Fahrlässige Körperverletzung, § 229 StGB',
    'Misshandlung von Schutzbefohlenen, § 225 StGB',
    'Beteiligung an einer Schlägerei, § 231 StGB',
    'Totschlag, § 212 StGB',
    'Mord, § 211 StGB',
    'Mordlust',
    'Befriedigung des Geschlechtstriebs',
    'Habgier',
    'Sonstige niedrige Beweggründe',
    'Heimtücke',
    'Grausamkeit',
    'Gemeingefährliche Mittel',
    'Verdeckungsabsicht',
    'Ermöglichungsabsicht',
    'Verhältnis zwischen Mord und Totschlag',
    'Tötung auf Verlangen, § 216 StGB',
    'Sterbehilfe',
    'Schwangerschaftsabbruch, §§ 218 ff. StGB',
    'Aussetzung, § 221 StGB',
    'Fahrlässige Tötung, § 222 StGB',
    'Freiheitsberaubung, § 239 StGB',
    'Nötigung, § 240 StGB',
    'Erpresserischer Menschenraub/Geiselnahme, § 239a, b StGB',
    'Menschenraub, § 234 StGB',
    'Bedrohung, § 241 StGB',
    'Hausfriedensbruch, § 123 StGB',
    'Verletzung der Vertraulichkeit des Wortes, § 201 StGB',
    'Verletzung des Briefgeheimnisses, § 202 StGB',
    'Ausspähen und Abfangen von Daten etc, § 202a f. StGB',
    'Verletzung von Privatgeheimnissen, §§ 203 f. StGB',
    'Beleidigung, § 185 StGB',
    'Üble Nachrede, § 186 StGB',
    'Verleumdung, § 187 StGB',
    'Verunglimpfung des Andenkens Verstorbener, § 189 StGB',
    'Wahrnehmung berechtigter Interessen, § 193 StGB',
    'Urkundenfälschung, § 267 StGB',
    'Fälschung technischer Aufzeichnungen, § 268 StGB',
    'Datenfälschung, § 269 StGB',
    'Urkundenunterdrückung, § 274 StGB',
    'Falschbeurkundung, § 271 StGB',
    'Falschbeurkundung im Amt, § 348 StGB',
    'Fälschung von Gesundheitszeugnissen, § 277 StGB',
    'Unrichtige Gesundheitszeugnisse, §§ 278, 279 StGB',
    'Datenunterdrückung, § 303a StGB',
    'Einfache Brandstiftung, § 306 StGB',
    'Schwere Brandstiftung, § 306a StGB',
    'Besonders schwere Brandstiftung, § 306b StGB',
    'Brandstiftung mit Todesfolge, § 306c StGB',
    'Fahrlässige Brandstiftung, § 306d StGB',
    'Herbeiführen einer Brandgefahr, § 306f StGB',
    'Tätige Reue, § 306e StGB',
    'Trunkenheit im Verkehr, § 316 StGB',
    'Gefährdung des Straßenverkehrs, § 315c StGB',
    'Gefährliche Eingriffe in den Straßenverkehr, § 315b StGB',
    'Unerlaubtes Entfernen vom Unfallort, § 142 StGB',
    'Uneidliche Falschaussage, § 153 StGB',
    'Meineid, § 154 StGB',
    'Falsche Versicherung an Eides Statt, § 156 StGB',
    'Aussagenotstand, § 157 StGB',
    'Berichtigung der Falschaussage, § 158 StGB',
    'Versuchte Anstiftung zur Falschaussage, § 159 StGB',
    'Verleitung zur Falschaussage, § 160 StGB',
    'Fahrlässiger Falscheid, § 161 StGB',
    'Widerstand gegen Vollstreckungsbeamte, § 113 StGB',
    'Landfriedensbruch, § 125 StGB',
    'Nichtanzeige einer geplanten Straftat, § 138 StGB',
    'Vortäuschen einer Straftat, § 145d StGB',
    'Falsche Verdächtigung, § 164 StGB',
    'Strafvereitelung, § 258 StGB',
    'Strafvereitelung im Amt, § 258a StGB',
    'Körperverletzung im Amt, § 340 StGB',
    'Vollrausch, § 323a StGB',
    'Unterlassene Hilfeleistung, § 323c StGB',
    'Zeugnisverweigerungsrecht',
    'nemo tenetur-Grundsatz',
    'Beweisaufnahme/Ablehnung von Beweisanträgen',
    'Beweisverwertung',
    'Untersuchungshaft',
    'Verdachtsformen',
    'Richtervorbehalt',
    'Strafklageverbrauch'
  ],
  
  'Öffentliches Recht': [
    'Staatsrecht',
    'Grundrechte',
    'Verwaltungsprozessrecht',
    'Verwaltungsrecht AT',
    'Staatsorganisationsrecht',
    'Polizei- und Ordnungsrecht',
    'Völker- und Europarecht',
    'Sonstiges Verwaltungsrecht BT',
    'Staatshaftungsrecht',
    'Baurecht',
    'Kommunalrecht',
    'Verfassungsbeschwerde',
    'Allgemeine Grundrechtslehre',
    'Grundrechtsfähigkeit/-mündigkeit',
    'Grundrechtsbindung',
    'Grundrechtseingriff',
    'Grundrechtskonkurrenzen',
    'Art. 19 I-III GG',
    'Einzelne Grundrechte/grundrechtsgleiche Rechte',
    'Menschenwürde, Art. 1 I GG',
    'Allgemeine Handlungsfreiheit, Art. 2 I GG',
    'Allg. Persönlichkeitsrecht, Art. 2 I i.V.m. Art. 1 I GG',
    'Recht auf Leben/körperliche Unversehrtheit, Art. 2 II 1 GG',
    'Freiheit der Person, Art. 2 II 2, 104 GG',
    'Gleichheitssatz, Art. 3 GG',
    'Glaubens- und Gewissensfreiheit, Art. 4 GG',
    'Meinungs-/Presse-/Informationsfreiheit, Art. 5 I GG',
    'Kunst-/Wissenschaftsfreiheit, Art. 5 III GG',
    'Schutz von Ehe und Familie, Art. 6 GG',
    'Schulische Grundrechte, Art. 7 GG',
    'Versammlungsfreiheit, Art. 8 GG',
    'Vereinigungsfreiheit, Art. 9 GG',
    'Brief-/Post-/Fernmeldegeheimnis, Art. 10 GG',
    'Freizügigkeit, Art. 11 GG',
    'Berufsfreiheit, Art. 12 GG',
    'Unverletzlichkeit der Wohnung, Art. 13 GG',
    'Eigentumsfreiheit, Art. 14 GG',
    'Verbot der Ausbürgerung und Auslieferung, Art. 16 GG',
    'Petitionsrecht, Art. 17 GG',
    'Effektiver Rechtsschutz, Art. 19 IV GG',
    'Parteienprivileg, Art. 21 GG',
    'Gleicher Zugang zu öffentlichen Ämtern ua, Art. 33 GG',
    'Wahlrecht, Art. 38 GG',
    'Recht auf gesetzlichen Richter, Art. 101 GG',
    'Recht auf rechtliches Gehör, Art. 103 GG',
    'Verwaltungsrechtsweg',
    'Anfechtungsklage',
    'Verpflichtungsklage',
    'Fortsetzungsfeststellungsklage',
    'Leistungsklage',
    'Feststellungsklage',
    'Abstrakte Normenkontrolle',
    'Auslegung des Antrags',
    'Klagebefugnis',
    'Vorverfahren',
    'Klagefrist',
    'Klagegegner',
    'Beteiligtenfähigkeit',
    'Prozessfähigkeit',
    'Ordnungsgemäße Klageerhebung/Form',
    'Wiedereinsetzung in den vorherigen Stand',
    'Klagehäufung',
    'Begründetheit',
    'Nachschieben von Gründen',
    'Entscheidungserheblicher Zeitpunkt',
    'Vorläufiger Rechtsschutz',
    '§ 80 V VwGO',
    '§ 80a VwGO',
    '§ 123 VwGO',
    'Widerspruchsverfahren',
    'Verwaltungsakt',
    'Verwaltungsaktqualität',
    'Wirksamkeit',
    'Rechtmäßigkeit',
    'Ermächtigungsgrundlage/Verwaltungsaktbefugnis',
    'Formelle Rechtmäßigkeit',
    'Materielle Rechtmäßigkeit',
    'Bestimmtheit',
    'Unmöglichkeit',
    'Beurteilungsspielraum',
    'Ermessen',
    'Rechtsfolgen von Fehlern',
    'Aufhebung (Widerruf/Rücknahme)',
    'Nebenbestimmungen',
    'Rechtsnachfolge',
    'Zusicherung',
    'Öffentlich-rechtlicher Vertrag',
    'Satzungen',
    'Staatsstrukturprinzipien',
    'Demokratieprinzip',
    'Bundesstaatsprinzip',
    'Rechtsstaatsprinzip',
    'Gesetzgebung',
    'Gesetzgebungskompetenz',
    'Gesetzgebungsverfahren',
    'Verfassungsänderung',
    'Rechtsverordnungen',
    'Verwaltungskompetenzen',
    'Verfassungsorgane/-akteure',
    'Bundestag/Ausschüsse/Fraktionen/Abgeordnete',
    'Bundesrat',
    'Bundeskanzler/-regierung',
    'Bundespräsident',
    'Parteien',
    'Landesverfassungsrecht',
    'Verfassungsprozessrecht',
    'Organstreit',
    'Bund-Länder-Streit',
    'Konkrete Normenkontrolle',
    'Einstweilige Anordnung',
    'Ermächtigungsgrundlage',
    'Generalklauseln',
    'Standardmaßnahmen',
    'Öffentliche Sicherheit',
    'Öffentliche Ordnung',
    'Gefahr',
    'Verantwortlichkeit',
    'Verwaltungsvollstreckung',
    'Gestrecktes Verfahren',
    'Sofortiger Vollzug',
    'Kosten',
    'Androhung',
    'Festsetzung',
    'Zwangsmittel',
    'Abschleppfall',
    'Versammlungsrecht',
    'Abgrenzung repressives/präventives Handeln',
    'Ordnungsbehördliche Verordnung',
    'Europarecht',
    'Grundfreiheiten',
    'Unionsbürgerschaft',
    'Diskriminierungsverbot',
    'Verhältnis zum nationalen Recht',
    'Rechtsetzung',
    'Rechtsbehelfe',
    'Völkerrecht',
    'Schulrecht',
    'Beamtenrecht',
    'Straßenrecht',
    'Gewerberecht',
    'Ausländer-/Staatsangehörigkeitsrecht',
    'Presserecht',
    'Gaststättenrecht',
    'Waffenrecht',
    'Schadensersatz',
    'Öffentlich-rechtliches Schuldverhältnis (§ 280 BGB)/c.i.c.',
    'Amtshaftung (Art. 34 GG)',
    'Entschädigungsanspruch, § 39 OBG NRW',
    'Schadensersatz wegen Eigentumseingriffen',
    'Unterlassung/Folgenbeseitigung',
    'Ausgleichsansprüche',
    'Öffentlich-rechtlicher Erstattungsanspruch',
    'Öffentlich-rechtliche GoA',
    'Baugenehmigung',
    'Genehmigungspflichtigkeit',
    'Bauordnungsrechtliche Zulässigkeit',
    'Bauplanungsrechtliche Zulässigkeit',
    'Immissionsschutzrechtliche Zulässigkeit',
    'Bauordnungsrechtliche Verfügung',
    'Drittschützende Wirkung von Rechtsnormen',
    'Rechtmäßigkeit eines Bebauungsplans',
    'Selbstverwaltungsgarantie',
    'Kommunale Aufgaben',
    'Rechtsstellung der Gemeindebewohner',
    'Zugang zu öffentlichen Einrichtungen',
    'Bürgerbegehren/Bürgerentscheid',
    'Anschluss- und Benutzungszwang',
    'Gemeindeorgane',
    'Gemeinderat',
    '(Ober-)Bürgermeister',
    'Wirtschaftliche Tätigkeit von Gemeinden',
    'Kommunalaufsicht',
    'Kommunalverfassungsstreit',
    'VwGO',
    'Steuerrecht',
    'IT-Recht',
    'Datenschutzrecht',
    'Medienrecht',
    'Umweltrecht',
    'Sozialrecht'
  ]
} as const;

export type LegalCategory = keyof typeof LEGAL_TAGS_BY_CATEGORY;
export type LegalTag = typeof LEGAL_TAGS_BY_CATEGORY[LegalCategory][number];
